// extracted by mini-css-extract-plugin
export var actionButton = "StockTransferContentItem-module--actionButton--Ajuso";
export var container = "StockTransferContentItem-module--container--TT0bz";
export var detail = "StockTransferContentItem-module--detail--wLuV8";
export var details = "StockTransferContentItem-module--details--YLC2C";
export var info = "StockTransferContentItem-module--info--QrKtx";
export var name = "StockTransferContentItem-module--name--5pois";
export var thumbnailIndicator = "StockTransferContentItem-module--thumbnailIndicator--yZKE0";